import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";

class CorporateCustomerList extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      modal: false,
      userData: []   
    };
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {
    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE') {
      const url = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/fetchAll";
      fetch(url,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          return response.json();
        }
      ).then(data => {
        this.setState({ userData: data })
      })
    }
  }

  // delete = (id) => {
  //   const postCorporateCustomerData = {
  //     id: id
  //   };
  //   console.log(postCorporateCustomerData);
  //   fetch('/api/corp-customer/delete', {
  //     method: 'DELETE',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(postCorporateCustomerData)
  //   }).then(response => { if (response.ok) { this.componentDidMount() } })
  //     .then(data => console.log(data))
  //     .catch((err) => console.log(err))
  // };

  render() {

    let dataArr = [];
    this.state.userData.map((data) => {
		var usemail =   ""
		var usphoneNumber = ""
		if(data.user){
			usemail =   data.user.userEmail
			usphoneNumber =   data.user.userPhoneNumber
		}
      let mdData = [
        data.corporateId, data.companyName,usemail, usphoneNumber, data.contactNumber,
        data.doorNumber + ", " + data.streetName + ", " + data.area + ", " + data.city, data.id
      ];
      dataArr.push(mdData)
      return null;
    });


    const columns = [
      {
        name: "Id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "CompanyName",
        label: "Company Name",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "email",
        label: "Email",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "mobile",
        label: "Phone Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "ContactNumber",
        label: "Contact Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Address",
        label: "Address",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <><Button variant="outline-success" onClick={() => this.nextPath("/corp-customer/customer-details", value)} >
                Details </Button>
                {/* &nbsp;&nbsp;&nbsp;<Button variant="outline-danger" onClick={() => this.delete(value)} >
                  Delete </Button>  */}
              </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'Corporate Customer List.csv',
      },
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE') {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Corporate Customer Details</Breadcrumb.Item>
          </Breadcrumb>
          <div style={{ marginTop: "10px" }}>
            <Button className="float-right"
              variant="outline-success"
              style={{ marginTop: "10px", marginRight: "10px", width: "200px" }}
              onClick={() => this.nextPath("/corp-customer/customer-create")
              } >
              Add Customer
                    </Button>
            <MUIDataTable
              title={"Customer List"}
              data={dataArr}
              columns={columns}
              options={options} />
          </div>
        </>
      );
    } else {
      return (<></>);
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(CorporateCustomerList)
